<template>
  <div>
    <!-- 背景 -->
    <bg :pcImg='pcBannerImg' :mobileImg='mobileBannerImg'>
      <scroll-nav v-if="articleCatList.length>0" :active-index='this.$route.params.catid' :list='articleCatList' cusValue='value' cusKey='title' @scrollNavClick='scrollNavClick'></scroll-nav>
    </bg>

    <!-- 二级路由容器 -->
      <transition name="move" mode="out-in">
        <router-view :key="new Date().getTime()"></router-view>
      </transition>

  </div> 
</template>

<script>
import BG from '../components/common/BG'
import ScrollNav from '../components/common/ScrollNav'
import {navList} from '../project.config'

export default {
  data() {
    return {
      // navList,
      pcBannerImg: require('../assets/img/two_banner_bg5.jpg'),
      mobileBannerImg: require('../assets/img/two_banner_mobile_bg5.jpg'),
      articleCatList: navList[4].sub,
    }
  },
  components: {
    bg:BG,
    ScrollNav
  },
  methods: {
    scrollNavClick(e) {
      let {value} = e;
      this.$router.push(`/recruitment/${value}`)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/css/register.scss';
@import '../assets/css/base.scss';

  // tabs选项卡样式
  /deep/.el-tabs__item:hover {
    color: $basecolor;
    cursor: pointer;
  }
  /deep/.el-tabs__item.is-active {
      color: $basecolor;
  }
  /deep/.el-tabs__active-bar {
    background-color: $basecolor;
  }
  /deep/.el-tabs__nav-wrap.is-scrollable {
    padding: 0 30px;
  }
  /deep/.el-tabs__nav-prev {
    left: 7px;
  }
  /deep/.el-tabs__nav-next {
    right: 7px;
  }
  /deep/.el-tabs__item:nth-of-type(2) {
    padding-left: 200px !important;
  }

  @media screen and (max-width: 768px) {
    /deep/.el-tabs__item:nth-of-type(2) {
      padding-left: 0 !important;
    }
  }
</style>